import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import {
    ProductSliderStyles,
    productSlider
} from "@omni/ui/brand/product/productSlider/productSlider.styles";
import { Button } from "@omni/ui/components/Button/button.component";

import { useProductSliderContext } from "@/components/Product/ProductSlider/context/productSlider.context";

type Props = {
    type: "left" | "right";
    disabled?: boolean;
    className?: string;
};

export const NavButton = ({ type, disabled, className }: Props) => {
    const { source, allowPrev, mainSwiper, allowNext } =
        useProductSliderContext();

    const isDisabled = disabled ?? (type === "right" ? !allowNext : !allowPrev);

    const { slider_navButton, slider_navButton_icon } = productSlider();

    const handleOnClick = () => {
        if (isDisabled) return;

        if (type === "right") {
            mainSwiper?.slideNext();
        } else {
            mainSwiper?.slidePrev();
        }
    };

    return (
        <Button
            onClick={handleOnClick}
            color={ProductSliderStyles.navButtonColor}
            className={slider_navButton({
                isRecent: source === ProductSliderSources.Recent,
                type: type,
                className: className
            })}
            disabled={isDisabled}
        >
            <i className={slider_navButton_icon({ type: type })} />
        </Button>
    );
};
